import styled from 'styled-components';

export const Text = styled.span`
  line-height: 1.4rem;
`;
